import React, { useContext } from 'react';
import { AddStorageDataContext } from 'context/AddStorageContext';
import { INPUT_TYPES, storageNameMask } from 'utils/CommonConstants';
import InputField from 'sub_components/Common/BloxTextInput';
import styled from 'styled-components';

const ShareNameStyle = styled.div`
	.blox-text-input {
		width: 100%;
		margin-bottom: 8px;
	}
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
		.blox-text-input {
			margin-bottom: 20px;
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.blox-text-input {
			margin-bottom: 50px;
		}
	}
`;

export const ShareNameScreen = () => {
	const { inputs, change } = useContext(AddStorageDataContext);

	return (
		<ShareNameStyle>
			<InputField
				key='share-name-input'
				type={INPUT_TYPES.INPUT}
				label='Share Name'
				name='name'
				value={inputs?.name}
				onChange={change}
				active={true}
				mask={storageNameMask}
				hideCheckmark
				cypressId='share-name'
			/>
		</ShareNameStyle>
	);
};
